export const LOCAL_STORAGE_KEYS = {
    fundsData: (fileType: string) => `funds_${fileType}`,
    fundsEtag: (fileType: string) => `funds_etag_${fileType}`,
    handlerCodeMap: "handler_code_map",
    handlerCodeMapUpdatedAt: "handler_code_map_updated_at", 

    consultingTabsSelectedIndex: "consultingTabsSelectedIndex",
    gemelInvestigationTabsSelectedIndex: "gemelInvestigationTabsSelectedIndex",
    mimshakHierarchyView_Main_tab: "mimshak_hierarchy_view_main_tab", 
    mimshakHierarchyView_Commision_tab: "mimshak_hierarchy_view_commision_tab", 
    mimshakHierarchyView_Tree_Exposure_tab: "mimshak_hierarchy_view_tree_exposure_tab",
    mimshakHierarchyView_Tree_Last_data_tab: "mimshak_hierarchy_view_tree_last_data_tab",
    mimshakHierarchyView_group_by_chart: "mimshakHierarchyView_group_by_chart",
    insuranceProductDrawerSelectedTab: "insuranceProductDrawerSelectedTab",
    mimshakCommissionTabsSelectedIndex: "mimshakCommissionTabsSelectedIndex",
    revQuarterCommissionTabsSelectedIndex: "revQuarterCommissionTabsSelectedIndex",
    revQuarterBonusTabsSelectedIndex: "revQuarterBonusTabsSelectedIndex",
    mimshakBonusCommissionTabsSelectedIndex: "mimshakBonusCommissionTabsSelectedIndex",
    mimshakHierarchyView_Tree_Product_Distribution: "mimshak_hierarchy_view_tree_product_distribution",
    adminCompaniesTabsSelectedIndex: "adminCompaniesTabsSelectedIndex",
    consultingMainPageTabsSelectedIndex: "consultingMainPageTabsSelectedIndex",
  };

  export const HANDLER_CODE_MAP_TTL_MS = 2 * 1000; // 🕒 מרווח זמן מינימלי בין עדכונים: 2 דקות